import { useWLOrderFormSelector } from '@talos/kyoko';
import type { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import { StackScreen } from '../components/StackScreen';
import { CashTransactionRoute } from '../pages/CashTransaction/CashTransaction';
import { EntityDetailsPage } from './EntityDetailsPage';
import { SwapRoute } from './SwapForm/SwapForm';

export const SubRoute = ({ layout }: { layout: ReactElement }) => {
  const swapStep = useWLOrderFormSelector(state => state.swap.mode);

  return (
    <Routes>
      <Route path="*" element={layout}>
        <Route
          path="cash/*"
          element={
            <StackScreen initialTitle={swapStep === 'withdraw' ? 'Withdraw' : 'Top up'}>
              <CashTransactionRoute />
            </StackScreen>
          }
        />
        <Route
          path="swap/*"
          element={
            <StackScreen initialTitle="Trade">
              <SwapRoute />
            </StackScreen>
          }
        />
        <Route
          path="entity/*"
          element={
            <StackScreen canGoBack initialTitle="GCrypto+">
              <EntityDetailsPage />
            </StackScreen>
          }
        />
      </Route>
    </Routes>
  );
};
